import { render, staticRenderFns } from "./OnlineStore2Support.vue?vue&type=template&id=607ab770&scoped=true"
import script from "./OnlineStore2Support.vue?vue&type=script&lang=js"
export * from "./OnlineStore2Support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ab770",
  null
  
)

export default component.exports